<template>
  <v-combobox
    outlined
    hide-details
    dense
    :disabled="disabled"
    :value="value"
    :items="items"
    item-text="label"
    item-value="value"
    :return-object="true"
    :search-input.sync="searchInput"
    append-icon=""
    :filter="customFilter"
    @input="onInput"
    @focus="onFocus"
  >
    <template v-slot:append-item>
      <div v-if="loading" class="loading-row">
        <v-progress-circular indeterminate size="16" width="2" color="primary" class="mr-2" />
        <span class="loading-text">Searching suppliers...</span>
      </div>
      <div v-else-if="hasMore" class="load-more-row">
        <v-btn small text color="primary" @mousedown.prevent @click.stop="onLoadMore">Load more</v-btn>
      </div>
    </template>
    <template v-slot:item="{ item, on, attrs }">
      <!-- Render header item -->
      <v-list-item v-if="item.header" :key="item.header" style="pointer-events: none; cursor: default">
        <v-list-item-content>
          <v-list-item-title>{{ item.header }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- Render normal selectable item -->
      <v-list-item v-else v-bind="attrs" v-on="on" :key="item.value">
        <v-list-item-content>
          <v-list-item-title>{{ item.label }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-combobox>
</template>

<script>
export default {
  props: {
    value: Object,
    disabled: Boolean,
    items: Array,
    loading: Boolean,
    hasMore: Boolean,
  },
  data() {
    return {
      searchInput: "",
      isSyncingSearchInput: false,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        const nextValue = value?.label || "";
        if (nextValue === this.searchInput) return;

        this.isSyncingSearchInput = true;
        this.searchInput = nextValue;
        this.$nextTick(() => {
          this.isSyncingSearchInput = false;
        });
      },
    },
    searchInput(value) {
      if (this.isSyncingSearchInput) return;
      this.$emit("search", value || "");
    },
  },
  methods: {
    customFilter() {
      return true;
    },
    onInput(v) {
      const value = v === null ? { label: "", value: null } : typeof v === "string" ? { label: v, value: null } : v;
      this.$emit("input", value);
    },
    onFocus(e) {
      this.$emit("focus", e);
    },
    onLoadMore() {
      this.$emit("load-more");
    },
  },
};
</script>

<style scoped>
.loading-row {
  display: flex;
  align-items: center;
  padding: 8px 16px 12px;
}

.loading-text {
  color: rgba(0, 0, 0, 0.54);
  font-size: 12px;
  line-height: 1.2;
}

.load-more-row {
  display: flex;
  justify-content: center;
  padding: 4px 0 12px;
}
</style>
